import React, { useContext } from "react";
import { GlobalContext } from "../../contexts/GlobalContext";
import Breadcrumb from "../../components/Breadcrumb/Breadcrumb";
import CardContactMkt from "../../components/CardContactMkt/CardContactMkt";
import PageTitle from "../../components/PageTitle/PageTitle";
import { useParams } from "react-router-dom";
import NotFound from "../not-found/NotFound";
import "./ActiveNotices.css";
import ResponsiveImage from "../../components/ResponsiveImage/ResponsiveImage";
import LatestNews from "../../components/LatestNews/LatestNews";
import { primary } from "./../../theme/colors";

const ActiveNotices = () => {
  const { state } = useContext(GlobalContext);
  const { year, month, slug } = useParams();
  const pathActiveNotive = `notices/${year}/${month}/${slug}`;

  const language = state.language || "pt-br";
  let data;
  try {
    data = require(
      `../../assets/languages/${language}/${pathActiveNotive}.json`,
    );
  } catch (err) {
    console.error("Arquivo de notícia não encontrado:", err);
    return <NotFound />;
  }

  const {
    breadcrumb,
    selectedPage,
    pageTitle,
    author,
    postDate,
    html_content,
    cardMarketing,
  } = data;

  const homeData = require(`../../assets/languages/${language}/home.json`);
  const { contentCard, latestNews } = homeData;

  return (
    <>
      <Breadcrumb
        beforeRoutes={breadcrumb}
        selectedPage={selectedPage}
        ignoreMgBot={true}
      />
      <div className="main-container">
        <section className="section-container">
          <PageTitle title={pageTitle} />
          <div className="author-container">
            <span className="text-bold">{author}</span>
            <span>{postDate}</span>
          </div>

          <ResponsiveImage
            path={pathActiveNotive}
            image={"cover.png"}
            height="650px"
            isPublic={true}
            borderRadius={"rounded-img"}
          />

          <div
            className="mg-top-50 notice-container"
            dangerouslySetInnerHTML={{ __html: html_content }}
          >
            {/* o conteudo da noticia é controlado pelo json importado */}
          </div>
          {cardMarketing && (
            <div className="mg-top-50">
              <CardContactMkt />
            </div>
          )}

          <div className="main-container mg-top-50 mg-bot-70">
            <div className="section-container">
              <PageTitle title={latestNews} />
              <div className="card-news">
                {contentCard.map((d, i) => (
                  <LatestNews
                    key={i}
                    image={d.image}
                    dateNews={d.dateNews}
                    titleCard={d.titleNews}
                    content={d.contentNews}
                    labelBtn={d.labelButton}
                    textColor={primary.primary300}
                    pathNotice={`${d.date}/${d.slug}`}
                    force={true}
                  />
                ))}
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default ActiveNotices;
